import { CfDoubleContentBlockProps } from "../types";
import {
  convertCfAlignItemsProps,
  convertCfJustifyContentProps,
} from "utilities/cfPropTypes/cfFlex";
import { convertCfBackgroundProps } from "utilities/cfPropTypes/cfBackground";
import { convertCfSpacersProps } from "utilities/cfPropTypes/cfSpacers";
import DoubleContentBlock from "../index";
import React from "react";

export const convertCfDoubleContentBlockProps = ({
  customClass,
  doubleContentStyle,
  children,
}: CfDoubleContentBlockProps) => {
  return {
    customClass: customClass || "",
    ...convertCfAlignItemsProps(doubleContentStyle?.alignItems),
    ...convertCfJustifyContentProps(doubleContentStyle?.justifyContent),
    ...convertCfSpacersProps(doubleContentStyle?.spacers),
    children,
  };
};

const CfDoubleContentBlock = (props: CfDoubleContentBlockProps) => (
  <DoubleContentBlock {...convertCfDoubleContentBlockProps(props)} />
);

export default CfDoubleContentBlock;
